export const contrastOptions = {
    NORMAL: 'normal',
    INVERTED: 'inverted',
    YELLOW_ON_BLACK: 'yellow-on-black',
    YELLOW_ON_BLUE: 'yellow-on-blue',
    BLACK_ON_CREAM: 'black-on-cream',
};

export default {
    BREAKPOINT_MOBILE: 750,
    BREAKPOINT_DESKTOP: 1280,
    ZOOM_FACTOR: {
        SMALL: 'zoom-small',
        MEDIUM: 'zoom-medium',
        LARGE: 'zoom-large',
    },
    CONTRAST_OPTIONS: [
        contrastOptions.NORMAL,
        contrastOptions.INVERTED,
        contrastOptions.YELLOW_ON_BLACK,
    ],
    VIEW_SIZE: { MOBILE: 'mobile', TABLET: 'tablet', DESKTOP: 'desktop' },
    ORIENTATION: { LANDSCAPE: 'landscape', PORTRAIT: 'portrait' },
    GAP_MATCH_SELECTOR_ID: 'gap-match-token-portal',
    GAP_MATCH_SCROLL_CLASS: 'gap-match-scroll-adjustment',
    SCALABLE_INTERACTION_IMAGE_CLASS: 'supports-image-scaling',
    PLAYER_LOADER_SELECTOR_ID: 'loader-container',
    TRUNCATED_ANNOTATION_LENGTH: 100,
    TEST_PLAYER_STYLES: ['primary_school_1', 'primary_school_2'],
    DARK_CONTRAST_COLORS: [
        contrastOptions.YELLOW_ON_BLACK,
    ],
    SECTION_LAYOUT: {
        BASIC_LEFT: 'basic-left',
        BASIC: 'basic',
        VERTICAL_LEFT: 'vertical-left',
        VERTICAL_TOP: 'vertical-top',
        VERTICAL: 'vertical',
    },
    STIMULUS_POSITION: {
        TOP: 'top',
        LEFT: 'left',
    },
    STIMULUS_HOLDER: {
        SECTION: 'section',
        QUESTION: 'question',
    },
    STIMULUS_STATE: {
        DRAG: 'drag',
        DROP: 'drop',
    },
    ANSWER_KEYS: {
        ANY_ORDER: 'IN ANY ORDER',
    },
};
